import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, inject } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { map, Observable, Subject, Subscription, take, takeUntil } from 'rxjs'
import { CommonModule, NgIf } from '@angular/common'
import {
  blockBusiness,
  blockBusinessFailure,
  blockBusinessSuccess,
  createBusiness,
  createBusinessFailure,
  createBusinessSuccess,
  deleteBusiness,
  deleteBusinessFailure,
  deleteBusinessSuccess,
  loadBusinesses
  // unblockBusiness
} from '../../../store/business/business.actions'
import { Business } from '../../../store/business/business.state'
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { NavigationEnd, Router, RouterModule } from '@angular/router'
import { CapitalizePipe } from '../../../pipes/capitalize.pipe'
import { environment } from '../../../../environments/environment'
import { AuthService } from '../../../services/auth.service'
import { BlockUnblockComponent } from '../template/block-unblock/block-unblock.component'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { trigger, transition, style, animate } from '@angular/animations'
import { DeleteComponent } from '../template/delete/delete.component'
import {
  selectActiveCount,
  selectAllBusinesses,
  selectInactiveCount,
  selectTotalCount
} from '../../../store/business/business.selectors' // Adjust the import path
import { PaginationComponent } from '../template/pagination/pagination.component'
// import { BusinessOwner } from '../../store/business-owner/business-owner.state'
import { selectAllBusinessOwners } from '../../../store/business-owner/business-owner.selectors'
import { loadBusinessOwners } from '../../../store/business-owner/business-owner.actions'
import { validateImage } from '../../../utils/imageValidator'
import { selectUser } from '../../../store/auth/auth.selectors'
import { AuthState, User } from '../../../store/auth/auth.state'
import { selectLoading, selectTotalRowCount } from '../../../store/business/business.reducer'
import { NgSelectModule } from '@ng-select/ng-select'
import { Actions, ofType } from '@ngrx/effects'
import { eps } from '../../../services/url.service'
import { UtilsService } from '../../../services/utils.service'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'
import { SharedModule } from '../../../shared/shared.module'
import { BusinessService } from '../../../services/business.service'
import { PlanResponse, PlansListResponse, PlansService } from '../../../services/plans.service'
import { ToastrService } from 'ngx-toastr'
import { noLeadingTrailingSpaces } from '../../../validators/no-leadingTraillingSpace.validators'
import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts'

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrl: './business.component.scss',
  imports: [
    ReactiveFormsModule,
    NgIf,
    CommonModule,
    RouterModule,
    CapitalizePipe,
    BlockUnblockComponent,
    FormsModule,
    DeleteComponent,
    PaginationComponent,
    NgSelectModule,
    HasPermissionDirective,
    SharedModule,
    NgApexchartsModule
    // BrowserAnimationsModule
  ],
  // animations: [
  //   trigger('fadeIn', [
  //     transition(':enter', [style({ opacity: 0 }), animate(300, style({ opacity: 1 }))]),
  //     transition(':leave', [animate(300, style({ opacity: 0 }))])
  //   ])
  // ]
  animations: [
    trigger('flyInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate(300, style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [animate(300, style({ transform: 'translateY(-100%)', opacity: 0 }))])
    ])
  ]
})
export class BusinessComponent implements OnInit, OnDestroy {
  private store = inject(Store) // Inject store using `inject()`
  // public defaultImg = '../../../../assets/img/user.jpg'
  public defaultImg = '../../../../assets/img/building.png'
  public imagePath: any
  public imageURL: string | null = this.defaultImg
  public apiEndpoint = environment.apiBaseUrl
  businessimageObjectURL: string | null = this.defaultImg // To store the object URL for the image
  // To store business images
  businessImages: { [key: string]: string } = {} // Ensure this is defined correctly
  @ViewChild('addBusinessModals') addBusinessModals!: TemplateRef<any>
  private modalRef!: NgbModalRef
  @ViewChild('totalChart') totalChart!: ChartComponent
  @ViewChild('activeChart') activeChart!: ChartComponent
  @ViewChild('inactiveChart') inactiveChart!: ChartComponent
  // businesses = this.store
  //   .select(state => state.business.businesses)
  //   .subscribe(businesses => {
  //     console.log('businesses', businesses)
  //     return businesses
  //   })
  // businesses$: Observable<Business[]> = this.store.select(state => state.business.businesses)
  totalCount$: Observable<number>
  activeCount$: Observable<number>
  inactiveCount$: Observable<number>
  totalRowCount$: Observable<number>
  businesses$: Observable<Business[]> = this.store.select(selectAllBusinesses)
  // businessesModal$: Observable<Business[]> = this.store.select(selectAllBusinesses)
  businessesModal$ = this.store
    .select(selectAllBusinesses)
    .pipe(map(businesses => businesses.filter(b => b.businessName?.toLowerCase() !== 'AVR HRMS')))

  currentPage = 1
  pageLimit = 10
  loading$: Observable<boolean> = this.store.select(state => state.business.loading)
  error$: Observable<string | null> = this.store.select(state => state.business.error)
  private businessesSubscription: Subscription | undefined
  // response: unknown = {}
  businesses: Business[] = []
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: any
  blockBusinessId = ''
  totalCount = 0
  activeCount = 0
  inactiveCount = 0
  totalRowCount = 0
  pageLastRecord = 0
  businessOwners$: Observable<User[]> = this.store.select(selectAllBusinessOwners)
  form!: FormGroup
  currentStep = 1
  steps = [1, 2, 3, 4] // Steps for the form
  user: AuthState['user'] | null = null
  businessIdss!: string[]
  businessOwner!: string | null
  isLoading$ = this.store.pipe(select(selectLoading))
  status = ''
  selectedBusiness = ''
  plansService = inject(PlansService)
  plans: PlanResponse[] = []
  selectedPlanType: 'monthly' | 'yearly' | null = null
  selectedPlanStatus: 'active' | 'inactive' | null = 'active'
  toastr = inject(ToastrService)
  isLoadingPlans = false
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(
    private authService: AuthService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private actions$: Actions,
    private utilsService: UtilsService,
    private router: Router,
    private businessService: BusinessService
  ) {
    this.businesses$ = this.store.select(selectAllBusinesses)
    this.businessOwners$ = this.store.select(selectAllBusinessOwners)
    // this.totalCount$ = this.store.select(selectTotalCount).pipe(
    //   map(totalCount => totalCount || 0) // Default to 0 if totalCount is null
    // )
    this.totalCount$ = this.store.select(selectTotalCount).pipe(
      map(totalCount => totalCount || 0) // Default to 0 if totalCount is null
    )

    // Subscribe to totalCount$ safely
    this.totalCount$.subscribe(count => {
      this.totalCount = count // Define this.totalCount in your class
    })

    this.activeCount$ = this.store.select(selectActiveCount).pipe(
      map(activeCount => activeCount || 0) // Default to 0 if totalCount is null
    )

    // Subscribe to totalCount$ safely
    this.activeCount$.subscribe(count => {
      this.activeCount = count // Define this.totalCount in your class
    })

    this.inactiveCount$ = this.store.select(selectInactiveCount).pipe(
      map(inactiveCount => inactiveCount || 0) // Default to 0 if totalCount is null
    )

    // Subscribe to totalCount$ safely
    this.inactiveCount$.subscribe(count => {
      this.inactiveCount = count // Define this.totalCount in your class
    })

    this.totalRowCount$ = this.store.select(selectTotalRowCount).pipe(
      map(totalRowCount => totalRowCount || 0) // Default to 0 if totalCount is null
    )

    // Subscribe to totalCount$ safely
    this.totalRowCount$.subscribe(count => {
      this.totalRowCount = count // Define this.totalCount in your class
    })

    this.form = this.fb.group({
      businessName: ['', Validators.required],
      picture: [null],
      website: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^(https?:\\/\\/)?(www\\.)?[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}(:[0-9]+)?(\\/.*)?$'
          )
        ]
      ],
      userId: [''],
      source: ['Portal'],
      // parentBusinessId: ['', [Validators.required]]
      isChildBusiness: [false, Validators.required],
      parentBusinessId: [{ value: null, disabled: true }],
      // planId: [{ value: null, disabled: false }, Validators.required],
      // ownerFirstName: ['', Validators.required],
      // ownerLastName: ['', Validators.required],
      // ownerEmail: ['', [Validators.required, Validators.email]],
      // ownerMobile: [
      //   '',
      //   [Validators.required, this.phoneNumberValidator(), noLeadingTrailingSpaces()]
      // ]
      planId: [{ value: null, disabled: false }],
      ownerFirstName: [''],
      ownerLastName: [''],
      ownerEmail: [''],
      ownerMobile: ['']
    })
  } // No need to explicitly inject Store here

  showModal = false
  isBlocking!: boolean // Assuming this will be set before opening the modal
  showDeleteModal = false
  search = ''
  private destroyed$ = new Subject<void>()
  allBusinesses: any[] = []
  isLoadingBusinesses = false

  ngOnInit() {
    this.status = 'false'
    this.store
      .select(selectUser)
      .pipe(take(1))
      .subscribe(user => {
        this.user = user
        this.form.get('parentBusinessId')?.setValue(user?.businessId)

        if (user?.employmentType === 'Business Owner') {
          this.form.get('parentBusinessId')?.enable()
        }
        //this.selectedBusiness = user?.business?.id

        // this.businessList = user?.businesses
        //if (this.user?.role.name === 'Business Owner') {
        //  this.selectedBusinessOwner = this.user.businessOwnerId
        //}
        // this.getAttendancePolicyList()
        const businessIds = user?.businessIds // your array of business IDs
        // const paramString = `ids=${businessIds?.join(',') ?? ''}`;
        if (businessIds && businessIds.length) {
          this.businessIdss = businessIds
          // const paramString = `businessIds=${businessIds.join(',')}&disabled=${this.status}`
          // this.store.dispatch(
          //   loadBusinesses({ params: paramString, limit: this.pageLimit, page: this.currentPage })
          // )
        }
        // else {
        //   this.loadAllBusinesses() // Load all businesses initially
        //   // this.loadAllBusinessOwners()
        // }
        this.loadAllBusinesses()
        this.loadAllBusinessOwners()
        this.loadAllBusinessesDirectly()
      })
    // this.store.dispatch(loadBusinesses({ filter: null }))
    // this.businessesSubscription = this.businesses$.subscribe(businesses => {
    //   // Optional: Handle businesses if you need to
    //   console.log('businesses', businesses)
    // })
    // console.log('businessId ::::>', this.businesses$)
    this.totalCount$.subscribe(count => {
      this.totalCount = count
      this.updatePageLastRecord()
    })
    this.activeCount$.subscribe(count => {
      this.activeCount = count
      this.updatePageLastRecord()
    })
    this.inactiveCount$.subscribe(count => {
      this.inactiveCount = count
      this.updatePageLastRecord()
    })
    this.totalRowCount$.subscribe(count => {
      this.totalRowCount = count
      this.updatePageLastRecord()
    })

    this.store.select(selectAllBusinesses).subscribe(businesses => {
      this.businesses = businesses
      businesses.forEach(emp => {
        if (emp.picture && !this.businessImages[emp.picture]) {
          this.businessImage(emp.picture)
        }
      })
    })

    this.actions$
      .pipe(
        ofType(blockBusinessSuccess, blockBusinessFailure),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.loadAllBusinesses()
        this.onClose()
        // this.form.reset()
        // this.modalService.dismissAll() // or modalRef.close() if you're using one
      })

    this.actions$
      .pipe(
        ofType(
          createBusinessSuccess,
          createBusinessFailure,
          deleteBusinessSuccess,
          deleteBusinessFailure
        ),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.loadAllBusinesses()
        this.loadAllBusinessOwners()
        // this.form.reset()
        // this.modalService.dismissAll() // or modalRef.close() if you're using one
        this.onClose()
      })

    // this.loadAllBusinesses()
    // this.businesses$.subscribe(businesses => {
    //   if (businesses.length === 1) {
    //     this.form.get('businessId')?.setValue(businesses[0].id)
    //     this.selectedBusinessId = businesses[0].id
    //     this.onBusinessChange(businesses[0].id)
    //   }
    // })

    this.businessOwners$.subscribe(owners => {
      if (this.user?.userRoles?.some(ur => ur.role?.name === 'Admin')) {
        return
      }

      if (owners.length === 1) {
        // this.form.get('businessId')?.setValue(businesses[0].id)
        this.businessOwner = owners[0].id
        // this.onBusinessChange(businesses[0].id)
        this.loadAllBusinesses()
      }
    })

    this.form.get('isChildBusiness')?.valueChanges.subscribe(isChild => {
      const parentCtrl = this.form.get('parentBusinessId')

      const ownerFields = ['ownerFirstName', 'ownerLastName', 'ownerEmail', 'ownerMobile', 'planId']

      if (isChild) {
        // Parent Business required
        parentCtrl?.enable()
        parentCtrl?.setValidators([Validators.required])

        // Owner details & plan not required
        ownerFields.forEach(field => {
          const control = this.form.get(field)
          control?.reset()
          control?.clearValidators()
          control?.disable()
          control?.updateValueAndValidity()
        })
      } else {
        // Parent Business not required
        parentCtrl?.reset()
        parentCtrl?.setValue(this.getAvrHrmsBusinessId(), { emitEvent: false })
        parentCtrl?.clearValidators()
        // parentCtrl?.disable()
        if (this.user?.employmentType !== 'Business Owner' && !isChild) {
          parentCtrl?.disable()
        }

        // Owner details & plan required
        ownerFields.forEach(field => {
          const control = this.form.get(field)
          control?.enable()

          switch (field) {
            case 'ownerEmail':
              control?.setValidators([Validators.required, Validators.email])
              break

            case 'ownerMobile':
              control?.setValidators([Validators.required, Validators.pattern('^[0-9]{10,15}$')])
              break

            default:
              control?.setValidators([Validators.required])
          }

          control?.updateValueAndValidity()
        })
      }

      parentCtrl?.updateValueAndValidity()
    })
    this.getPlans()
  }

  loadAllBusinesses() {
    const params: any = {}
    // if (this.businessIdss?.length) {
    //   params.businessIds = this.businessIdss.join(',')
    // }

    if (this.search) {
      params.businessName = this.search
    }

    if (this.businessOwner) {
      params.ownerId = this.businessOwner
    }

    if (this.status) {
      params.disabled = this.status
    }
    // console.log('page', this.currentPage)
    // console.log('limit', this.pageLimit)

    this.store.dispatch(
      loadBusinesses({
        params: new URLSearchParams(params).toString(),
        page: this.currentPage,
        limit: this.pageLimit,
        context: 'list'
      })
    )

    // if (this.businessIdss && this.businessIdss.length) {
    //   const paramString = `businessIds=${this.businessIdss.join(',')}`
    //   this.store.dispatch(
    //     loadBusinesses({ params: paramString, page: this.currentPage, limit: this.pageLimit })
    //   )
    // } else {
    //   this.store.dispatch(
    //     loadBusinesses({ params: null, page: this.currentPage, limit: this.pageLimit })
    //   ) // Load all businesses
    //   this.loadAllBusinessOwners()
    // }
  }

  loadAllBusinessOwners() {
    const params: any = {}
    // if (this.businessIdss?.length) {
    //   params.businessIds = this.businessIdss.join(',')
    // }
    this.store.dispatch(
      loadBusinessOwners({
        params: new URLSearchParams(params).toString()
      })
    ) // Load all businesses
  }

  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    this.businessesSubscription?.unsubscribe()
  }

  businessImage(picture: string) {
    const imageUrl = this.apiEndpoint + '/uploads/' + picture // Assuming this is the correct path
    this.authService.getImage(imageUrl).subscribe(
      imageBlob => {
        const objectURL = URL.createObjectURL(imageBlob)
        this.businessImages[picture] = objectURL // Store the object URL
      },
      error => {
        console.error('Error fetching image:', error)
      }
    )
  }

  // openModal(isBlocking: boolean, businessId: string) {
  //   this.isBlocking = isBlocking
  //   this.showModal = true
  //   this.blockBusinessId = businessId
  // }
  openModal(isBlocking: boolean, businessId: string) {
    const modalRef = this.modalService.open(BlockUnblockComponent)
    modalRef.componentInstance.isBlocking = isBlocking
    modalRef.componentInstance.recordId = businessId
    // this.blockBusinessId = businessId

    modalRef.result.then(
      result => {
        // Handle the result from the modal
        if (result) {
          // Call the service to update the business status
          this.handleConfirm(result)
        }
      },
      reason => {
        // Handle the dismiss case
        if (reason) {
          this.handleConfirm(reason)
        }
      }
    )
  }

  handleConfirm(data: { id: string; status: boolean }) {
    this.store.dispatch(blockBusiness({ id: data.id, disabled: data.status }))
  }

  // handleCancel() {
  //   this.showModal = false
  // }

  openDeleteModal(businessId: string) {
    const modalRef = this.modalService.open(DeleteComponent)
    modalRef.componentInstance.recordId = businessId
    modalRef.result.then(
      result => {
        // Handle the result from the modal
        if (result) {
          // Call the service to update the business status
          this.handleDeleteConfirm(result)
        }
      },
      reason => {
        // Handle the dismiss case
        if (reason) {
          this.handleDeleteConfirm(reason)
        }
      }
    )
  }

  handleDeleteConfirm(data: { id: string }) {
    this.store.dispatch(deleteBusiness({ id: data.id }))
  }

  // onSearch() {
  //   this.currentPage = 1 // Reset to the first page on search
  //   // Call the search function when the search term changes
  //   // const params = `businessName=${encodeURIComponent(this.search)}&ownerId=${encodeURIComponent(this.search)}` // Replace with your actual ownerId
  //   // const params = this.search ? `businessName=${encodeURIComponent(this.search)}` : null

  //   // this.store.dispatch(
  //   //   loadBusinesses({ params, page: this.currentPage, limit: this.pageLimit, context: 'list' })
  //   // ) // Dispatch action with filter
  //   this.loadAllBusinesses()
  // }

  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      this.loadAllBusinesses() // Reload businesses for the new page
      this.updatePageLastRecord()
    }
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalRowCount)
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.loadAllBusinesses() // Load employees with new page limit
    this.updatePageLastRecord()
  }

  onOwnerSelect(ownerId: string) {
    if (ownerId) {
      // Call a method to fetch data based on the selected owner
      const params = `ownerId=${encodeURIComponent(ownerId)}`

      this.store.dispatch(
        loadBusinesses({ params, page: this.currentPage, limit: this.pageLimit, context: 'list' })
      ) // Dispatch action with filter
    } else {
      const params = ''
      this.store.dispatch(
        loadBusinesses({ params, page: this.currentPage, limit: this.pageLimit, context: 'list' })
      ) // Dispatch action with filter
      // Handle the case where no owner is selected
      // console.log('No business owner selected')
    }
  }

  onFileChange(event: Event, imageid: string) {
    const inputElement = event.target as HTMLInputElement
    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0]
      const validationResult = validateImage(file)

      if (validationResult.valid) {
        console.log('Image is valid!', file)
        this.form.get('picture')?.setValue(file) // Set the file in the form control
        // this.validationError = '' // Clear any previous error messages
      } else {
        console.error('Validation error:', validationResult.message)
        // this.validationError = validationResult.message // Set the error message
      }

      const reader = new FileReader()
      reader.onload = e => {
        if (imageid === 'imageURL') {
          this.imageURL = e.target?.result as string
        }
      }

      reader.readAsDataURL(file)
    }
  }

  onClose() {
    // if (this.form) {
    //   this.form.reset(); // Reset the form if it is defined
    // }
    // this.modalService.dismissAll();
    // this.currentStep = 1;

    try {
      if (this.form) {
        // this.form.reset()
        const parentBusinessId = this.form.get('parentBusinessId')?.value
        this.form.reset(
          {
            source: 'Portal',
            isChildBusiness: false,
            parentBusinessId: parentBusinessId,
            planId: null,
            ownerFirstName: '',
            ownerLastName: '',
            ownerEmail: '',
            ownerMobile: ''
          },
          { emitEvent: false }
        )
        this.form.get('planId')?.enable()
        // this.form.get('planId')?.setValidators(Validators.required)
        this.form.get('planId')?.clearValidators()
        this.form.get('planId')?.updateValueAndValidity()
      }
      if (this.modalRef) {
        this.modalRef.close()
      }
      this.modalService.dismissAll()
      this.currentStep = 1
      this.blockBusinessId = ''
    } catch (error) {
      console.error('Error closing modal:', error)
    }
  }
  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
      if (control.hasError('email')) {
        return 'Please enter a valid email address'
      }
      if (control.hasError('pattern')) {
        // Check if it's a URL pattern error for social media fields
        if (controlName.includes('facebook')) {
          return 'Please enter a valid Facebook URL'
        } else if (controlName.includes('twitter')) {
          return 'Please enter a valid Twitter URL'
        } else if (controlName.includes('linkedin')) {
          return 'Please enter a valid LinkedIn URL'
        } else if (controlName.includes('skype')) {
          return 'Please enter a valid Skype username or invite link'
        } else if (controlName.includes('whatsapp')) {
          return 'Please enter a valid WhatsApp link'
        } else if (controlName.includes('instagram')) {
          return 'Please enter a valid Instagram URL'
        } else if (controlName.includes('website')) {
          return 'Please enter a valid website URL'
        } else {
          return 'The entered value is not valid'
        }
      }

      if (control.hasError('required')) {
        if (controlName === 'planId') {
          return 'Please select a plan to start the trial'
        }
        return 'This field is required'
      }
    }
    return null // No error
  }

  onSubmit() {
    if (this.form.valid) {
      const formData = new FormData()
      formData.append('businessName', this.form.get('businessName')?.value)
      formData.append('website', this.form.get('website')?.value)
      formData.append('parentBusinessId', this.form.get('parentBusinessId')?.value)

      const isChild = this.form.get('isChildBusiness')?.value
      const planId = this.form.get('planId')?.value
      if (!isChild && planId) {
        formData.append('planId', planId)
      }

      const picture = this.form.get('picture')?.value
      if (picture) {
        formData.append('picture', picture)
      }

      let userId = ''
      this.store.pipe(select(selectUser), take(1)).subscribe(user => {
        if (user && user.id) {
          // console.log(user)
          // formData.append('userId', user.id)
          userId = user.id
        } else {
          // Handle the case where the user is null or doesn't have an ID
          console.error('User is not logged in or ID is missing.')
          // You could throw an error, or handle this scenario as needed
        }
      })

      this.store.dispatch(
        createBusiness({
          businessName: this.form.get('businessName')?.value,
          picture: picture,
          website: this.form.get('website')?.value,
          userId: userId,
          parentBusinessId: this.form.get('parentBusinessId')?.value,
          planId: !isChild ? planId : null,
          ownerFirstName: !isChild ? this.form.get('ownerFirstName')?.value : null,
          ownerLastName: !isChild ? this.form.get('ownerLastName')?.value : null,
          ownerEmail: !isChild ? this.form.get('ownerEmail')?.value : null,
          ownerMobile: !isChild ? this.form.get('ownerMobile')?.value : null
        })
      )
    }
  }

  openBusinessModal(content: TemplateRef<any>, options: any = {}) {
    this.modalRef = this.modalService.open(content, {
      scrollable: false,
      centered: true,
      size: 'lg',
      ...options
    })
    this.modalRef.result.catch(() => {
      this.resetBusinessForm()
    })
  }

  resetBusinessForm() {
    const avrHrmsId = this.getAvrHrmsBusinessId()

    this.form.reset(
      {
        source: 'Portal',
        isChildBusiness: false,
        // parentBusinessId: avrHrmsId,
        parentBusinessId:
          this.user?.employmentType === 'Business Owner' ? this.user?.businessId : avrHrmsId,
        businessName: '',
        picture: null,
        website: '',
        userId: '',
        planId: null,
        ownerFirstName: '',
        ownerLastName: '',
        ownerEmail: '',
        ownerMobile: ''
      },
      { emitEvent: false }
    )

    // this.form.get('parentBusinessId')?.disable()
    if (this.user?.employmentType === 'Business Owner') {
      this.form.get('parentBusinessId')?.enable()
    } else {
      this.form.get('parentBusinessId')?.disable()
    }
    this.form.get('planId')?.enable()
    this.imageURL = this.defaultImg
  }

  customSearchFn = (term: string, item: any) => {
    // Handle undefined item and fields gracefully
    const first = item?.firstName || ''
    const last = item?.lastName || ''
    const fullName = `${first} ${last}`.toLowerCase()

    return fullName.includes(term?.toLowerCase() || '')
  }

  setCurrentPage() {
    this.currentPage = 1
    this.loadAllBusinesses()
  }

  onImageError(employee: any): void {
    employee.picture = null // fallback triggers initials
  }

  getInitials(firstName: string = '', lastName: string = ''): string {
    const firstInitial = firstName?.charAt(0) || ''
    const lastInitial = lastName?.charAt(0) || ''
    return (firstInitial + lastInitial).toUpperCase()
  }

  getDashboardRoute(): string {
    // return this.user?.role.name === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath
    const isAdmin = this.user?.userRoles?.some(ur => ur.role?.name === 'Admin')
    return isAdmin ? eps.dashboardPath : eps.employeeDashboardPath
  }

  // customSearchBusinessFn = (term: string, item: any) => {
  //   // Handle undefined item and fields gracefully
  //   const first = item?.firstName || ''

  //   const fullName = `${first}`.toLowerCase()

  //   return fullName.includes(term?.toLowerCase() || '')
  // }

  customSearchBusinessFn = (term: string, item: any) => {
    const businessName = item?.businessName || ''

    return businessName.toLowerCase().includes(term?.toLowerCase() || '')
  }

  loadAllBusinessesModal() {
    const params: any = {}
    // params.context = 'modal'
    // if (this.businessIdss?.length) {
    //   params.businessIds = this.businessIdss.join(',')
    // }
    params.disabled = false
    this.store.dispatch(
      loadBusinesses({
        params: new URLSearchParams(params).toString(),
        context: 'modal'
      })
    )
  }

  // loadAllBusinessesDirectly() {
  //   this.isLoadingBusinesses = true

  //   this.businessService
  //     .getBusinesses('disabled=false') // no page, no limit
  //     .subscribe({
  //       next: res => {
  //         this.allBusinesses = res.businesses || []
  //         this.isLoadingBusinesses = false
  //       },
  //       error: err => {
  //         console.error('Failed to load businesses', err)
  //         this.isLoadingBusinesses = false
  //       }
  //     })
  // }

  loadAllBusinessesDirectly() {
    this.isLoadingBusinesses = true

    this.businessService.getMultiBusinesses().subscribe({
      next: res => {
        console.log('MULTI BUSINESSES API RESPONSE:', res)
        // this.allBusinesses = res || []
        this.allBusinesses = [...this.allBusinesses, ...(res || [])].filter(
          (business, index, self) => index === self.findIndex(item => item.id === business.id)
        )

        if (this.user?.employmentType === 'Business Owner') {
          this.allBusinesses = this.allBusinesses.filter(
            business => business.userId === this.user?.id
          )
        }
        console.log('DROPDOWN BUSINESSES:', this.allBusinesses)
        this.isLoadingBusinesses = false
      },
      error: err => {
        console.error('Failed to load multi businesses', err)
        this.allBusinesses = []
        this.isLoadingBusinesses = false
      }
    })
  }

  getPlans() {
    const filters = {
      type: this.selectedPlanType,
      status: this.selectedPlanStatus,
      search: this.search.trim()
    }

    this.plansService.getPlans(filters).subscribe({
      next: (response: PlansListResponse) => {
        this.plans = response.plans
        this.isLoadingPlans = false
      },
      error: (error: { message: string }) => {
        this.toastr.error('Error fetching plans: ' + error.message)
        this.isLoadingPlans = false
      }
    })
  }

  customSearchPlanFn = (term: string, item: any) => {
    const name = item?.name || ''
    return name.toLowerCase().includes(term?.toLowerCase() || '')
  }

  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phoneNumber = control.value
      // This regex allows for a '+' followed by 1 to 3 digits (country code),
      // optionally followed by a space, and then 1 to 14 digits (the phone number).
      const valid = /^\+\d{1,3} ?\d{1,14}$/.test(phoneNumber)
      return valid ? null : { invalidPhoneNumber: true }
    }
  }

  getAvrHrmsBusinessId(): string | null {
    return (
      this.allBusinesses.find(
        business => business.businessName?.trim().toLowerCase() === 'avr hrms'
      )?.id ?? null
    )
  }

  public totalChartOptions: any = {
    series: [
      {
        name: 'Messages',
        data: [25, 66, 41, 12, 36, 9, 21]
      }
    ],
    chart: {
      type: 'area',
      width: 50,
      toolbar: { show: false },
      zoom: { enabled: false },
      sparkline: { enabled: true }
    },
    fill: {
      type: 'gradient',
      gradient: {
        opacityFrom: 0,
        opacityTo: 0
      }
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2.5,
      curve: 'smooth'
    },
    colors: ['#F26522'],
    tooltip: {
      theme: 'dark',
      fixed: { enabled: false },
      x: { show: false },
      marker: { show: false }
    }
  }

  public activeChartOptions: any = {
    series: [
      {
        name: 'Active Business Entities',
        data: [25, 66, 41, 12, 36, 9, 21]
      }
    ],
    chart: {
      type: 'area',
      width: 50,
      height: 50,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      },
      sparkline: {
        enabled: true
      },
      foreColor: '#fff'
    },
    fill: {
      type: 'gradient',
      gradient: {
        opacityFrom: 0,
        opacityTo: 0
      }
    },
    markers: {
      size: 0,
      colors: ['#55CE63'],
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: {
        size: 7
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '35%',
        endingShape: 'rounded'
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2.5,
      curve: 'smooth'
    },
    colors: ['#55CE63'],
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep']
    },
    tooltip: {
      theme: 'dark',
      fixed: {
        enabled: false
      },
      x: {
        show: false
      },
      y: {
        title: {
          formatter: () => ''
        }
      },
      marker: {
        show: false
      }
    }
  }

  public inactiveChartOptions: any = {
    series: [
      {
        name: 'Inactive Business Entities',
        data: [25, 66, 41, 12, 36, 9, 21]
      }
    ],
    chart: {
      type: 'area',
      width: 50,
      height: 50,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      },
      sparkline: {
        enabled: true
      },
      foreColor: '#fff'
    },
    fill: {
      type: 'gradient',
      gradient: {
        opacityFrom: 0,
        opacityTo: 0
      }
    },
    markers: {
      size: 0,
      colors: ['#F62D51'],
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: {
        size: 7
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '35%',
        endingShape: 'rounded'
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2.5,
      curve: 'smooth'
    },
    colors: ['#F62D51'],
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep']
    },
    tooltip: {
      theme: 'dark',
      fixed: {
        enabled: false
      },
      x: {
        show: false
      },
      y: {
        title: {
          formatter: () => ''
        }
      },
      marker: {
        show: false
      }
    }
  }

  get isAdmin(): boolean {
    return this.utilsService.isAdmin()
  }
}
